import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
//import Select from 'react-dropdown-select';
import Select from 'react-select';
import DSelect from 'react-dropdown-select';

import Modal from 'react-modal';
import Loading from 'react-simple-loading';

const ShiftSchedule = ({ getContractDetails }) => {
    const navigate = useNavigate();
    const params = useParams();
    const contract_id = params.contract_id;
    const [isBtn, setIsBtn] = useState(false);
    const [shiftSchedule, setShiftSchedule] = useState(null);
    const [contract, setContract] = useState(null);

    const [shiftSchedules, setShiftSchedules] = useState(null);
    const [addShiftScheduleModalOpen, setAddShiftScheduleModalOpen] = useState(false);

    const [shift, setShift] = useState(null);
    const [shiftStart, setShiftStart] = useState(false);
    const [shiftEnd, setShiftEnd] = useState(false);


    const [errors, setErrors] = useState(null);
    const options_hours = Array.from({ length: 12 }, (_, i) => ({ label: (i + 1).toString().padStart(2, '0'), value: (i + 1).toString().padStart(2, '0') }));
    const options_meridiems = [{ label: "AM", value: "AM" }, { label: "PM", value: "PM" }];


    const onChangeStartTimeHours = async (e) => {

        console.log(shift);

        if (shift?.start_time_meridiems?.length > 0) {

            setShift({ ...shift, start_time_hours: e[0].value, start_time: (e[0].value + ":00 " + shift?.start_time_meridiems) })


        }
        else {
            setShift({ ...shift, start_time_hours: e[0]?.value, start_time: "" })

        }

    }

    const onChangeStartTimeMeridiems = async (e) => {

        console.log(e);
        if (e[0] && shift?.start_time_hours?.length > 0) {

            setShift({ ...shift, start_time_meridiems: e[0].value, start_time: (shift?.start_time_hours + ":00 " + e[0].value) })


        }
        else {
            setShift({ ...shift, start_time_meridiems: e[0]?.value, start_time: "" })

        }

    }


    const onChangeEndTimeHours = async (e) => {

        console.log(shift);

        if (shift?.end_time_meridiems?.length > 0) {

            setShift({ ...shift, end_time_hours: e[0].value, end_time: (e[0].value + ":00 " + shift?.end_time_meridiems) })

        }
        else {
            setShift({ ...shift, end_time_hours: e[0]?.value, end_time: "" })

        }
        // setShift({ ...shift, end_time: e })

    }

    const onChangeEndTimeMeridiems = async (e) => {


        if (e[0] && shift?.end_time_hours?.length > 0) {

            setShift({ ...shift, end_time_meridiems: e[0].value, end_time: (shift?.end_time_hours + ":00 " + e[0].value) })

        }
        else {

            setShift({ ...shift, end_time_meridiems: e[0]?.value, end_time: "" })

        }

    }


    useEffect(() => {

        window.scrollTo(0, 0)

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getContract();


    }, []);


    const convertTo12Hour = (time24) => {
        const [hour, minute] = time24.split(":").map(Number);
        const ampm = hour >= 12 ? "PM" : "AM";
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minute.toString().padStart(2, "0")} ${ampm}`;
    };



    const tConvert = (time) => {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) {
            time = time.slice(1);
            time[5] = +time[0] < 12 ? 'AM' : 'PM';
            time[0] = +time[0] % 12 || 12;
        }
        return time.join('');
    }
    const convertTime12to24 = (time12h) => {

        var hours = Number(time12h.match(/^(\d+)/)[1]);
        var minutes = Number(time12h.match(/:(\d+)/)[1]);
        var AMPM = time12h.match(/\s(.*)$/)[1];
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        return sHours + ":" + sMinutes;

    }
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && !isNaN(n - 0)
    }



    const getContract = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-contract-by-id/" + contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                //  if(response.data?.contract?.shift_schedule_id > 0){
                setShiftSchedule(response.data.contract)
                setContract(response.data.contract)

                // }
                // Parse shift_details JSON string
                let details = null;
                 if (response.data.contract?.shift_detail) {
                    details = JSON.parse(response.data.contract.shift_detail);
                }

if (details && details.start_time && details.end_time) {
    const daysObj = {};
    for (let i = 0; i <= 6; i++) {
        daysObj[`day${i}`] = details.days?.includes(i) || false;
    }

    const shiftObj = {
        start_time: convertTo12Hour(details.start_time),
        end_time: convertTo12Hour(details.end_time),
        ...daysObj,
    };

    setShift(shiftObj);
} 
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Request Contract Not Found", text: error.message });

            });
    }

    const saveShiftSchedule = async (e) => {
        e.preventDefault();
        setIsBtn(true);

        let errors = {};
        let is_error = false;

        const regex = /((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/;

        // Validate time
        if (!shift?.start_time || !shift?.end_time || !regex.test(shift?.start_time) || !regex.test(shift?.end_time)) {
            errors["time"] = "Please enter valid start and end time.";
            is_error = true;
        }

      
        // Collect day indices (e.g. [1, 5])
        const selectedDays = Array.from({ length: 7 }, (_, i) => i)
            .filter(i => shift?.[`day${i}`]);

        if (selectedDays.length === 0) {
            errors["days"] = "Please select one or more shift days.";
            is_error = true;
        }

        // Show error
        if (is_error) {
            Swal.fire({ icon: "error", title: "Error", text: Object.values(errors).join(" ") });
            setIsBtn(false);
            return false;
        }

          const s_time = convertTime12to24(shift?.start_time || '');
        const e_time = convertTime12to24(shift?.end_time || '');

        // Final payload
        const payload = {
            start_time: s_time,
            end_time: e_time,
            days: selectedDays,
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/save-contract-shift-schedule-by-id`,
                { shift_schedule: payload, contract_id: contract_id },
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );

            if (response?.data?.status) {
                setAddShiftScheduleModalOpen(false);
                getContractDetails();
                getContract();
            } else {
                Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error", text: error.message });
        } finally {
            setIsBtn(false);
        }
    };




    return (

        <>

            <div className="input-box" onClick={() => { getContract(); setAddShiftScheduleModalOpen(true) }} >

                <label className="color-light fs-14 flex-grow-1"  >{contract?.days ? contract?.days + "*" : ""}{contract?.hours} </label>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                </svg>
            </div>

            <Modal
                isOpen={addShiftScheduleModalOpen}
                onRequestClose={() => { setAddShiftScheduleModalOpen(false) }}
                contentLabel="Add Shift Schedule"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >

                    <div className=" justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Shift Schedule</h3>
                    <div className=" justify-content-end" >
                        <div className="icon" onClick={() => setAddShiftScheduleModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>

                    </div>

                </div>
                <form onSubmit={saveShiftSchedule} action="#"  >

                    <div className="modal-body min-height" >
                        <div className="box modal align-self-stretch"  >




                            <div className="card p-16 align-items-stretch color-white bg-grey">
                                {errors && errors["time"] &&
                                    <div className="error">{errors["time"]}</div>
                                }

                                <div className="fd-row justify-content-space-between  align-items-center" >
                                    <label className="fs-14" >Start Time</label>
                                    <label onClick={() => { setShiftStart(true); setShiftEnd(false); }} className={shiftStart ? "btn btn-secondary selected" : "btn btn-secondary"} >{shift?.start_time ? tConvert(shift?.start_time) : "__ : __"}</label>

                                </div>

                                {shiftStart &&
                                    <div className="fd-row justify-content-center  align-items-center " >

                                        <div className="time-picker-grey fd-row justify-content-center  align-items-center " >

                                            <div className="fd-row" >
                                                <DSelect
                                                    id="start_time_hours"
                                                    options={options_hours}
                                                    labelField="label"
                                                    valueField="value"
                                                    placeholder="__"
                                                    className="form-control"
                                                    dropdownHandle={false}
                                                    color="#000000"
                                                    onChange={onChangeStartTimeHours}
                                                    values={shift?.start_time_hours && [{ "label": shift?.start_time_hours, "value": shift?.start_time_hours }]}

                                                />
                                                <label className="time-picker-separator">: </label>
                                                <DSelect
                                                    options={options_meridiems}
                                                    id="start_time_meridiems"
                                                    labelField="label"
                                                    valueField="value"
                                                    placeholder="__"
                                                    className="form-control"
                                                    dropdownHandle={false}
                                                    color="#000000"
                                                    onChange={onChangeStartTimeMeridiems}
                                                    values={shift?.start_time_meridiems && [{ "label": shift?.start_time_meridiems, "value": shift?.start_time_meridiems }]}

                                                />


                                            </div>
                                        </div>
                                    </div>
                                }

                                {shiftEnd &&
                                    <div className="fd-row justify-content-center  align-items-center " >

                                        <div className="time-picker-grey fd-row justify-content-center  align-items-center " >

                                            <div className="fd-row" >
                                                <DSelect
                                                    id="end_time_hours"
                                                    options={options_hours}
                                                    labelField="label"
                                                    valueField="value"
                                                    placeholder="__"
                                                    className="form-control"
                                                    dropdownHandle={false}
                                                    color="#000000"
                                                    onChange={onChangeEndTimeHours}
                                                    values={shift?.end_time_hours && [{ "label": shift?.end_time_hours, "value": shift?.end_time_hours }]}


                                                />
                                                <label className="time-picker-separator"> : </label>

                                                <DSelect
                                                    id="end_time_meridiems"
                                                    options={options_meridiems}
                                                    labelField="label"
                                                    valueField="value"
                                                    placeholder="__"
                                                    className="form-control"
                                                    dropdownHandle={false}
                                                    color="#000000"
                                                    onChange={onChangeEndTimeMeridiems}
                                                    values={shift?.end_time_meridiems && [{ "label": shift?.end_time_meridiems, "value": shift?.end_time_meridiems }]}


                                                />


                                            </div>
                                        </div>
                                    </div>
                                }


                                <div className="fd-row justify-content-space-between  align-items-center" >
                                    <label className="fs-14" >End Time</label>
                                    <label onClick={() => { setShiftStart(false); setShiftEnd(true); }} className={shiftEnd ? "btn btn-secondary selected" : "btn btn-secondary "} >{shift?.end_time ? tConvert(shift?.end_time) : "__ : __"}</label>

                                </div>
                            </div>


                            <div className="fd-row g-8 ">
                                <div className="fd-column input-container" >
                                    <label >Shift Days</label>
                                    <div className="fd-row g-8">
                                        <label className={shift?.day0 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day0: !shift?.day0 })} >S</label>
                                        <label className={shift?.day1 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day1: !shift?.day1 })}>M</label>
                                        <label className={shift?.day2 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day2: !shift?.day2 })}>T</label>
                                        <label className={shift?.day3 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day3: !shift?.day3 })}>W</label>
                                        <label className={shift?.day4 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day4: !shift?.day4 })}>T</label>
                                        <label className={shift?.day5 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day5: !shift?.day5 })}>F</label>
                                        <label className={shift?.day6 ? "day selected" : "day"} onClick={() => setShift({ ...shift, day6: !shift?.day6 })}>S</label>
                                    </div>
                                    {errors && errors["days"] &&
                                        <div className="error">{errors["days"]}</div>
                                    }

                                </div>
                            </div>




                        </div>
                    </div>
                    <div className="modal-footer  justify-content-space-between" >
                        <button className="btn btn-secondary" type="button" onClick={() => { setAddShiftScheduleModalOpen(false) }}>Cancel</button>
                        <button className=" btn btn-primary" type="submit" disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>


                    </div>
                </form>
            </Modal>
        </>

    );
};

export default ShiftSchedule;